import React from "react";

const AssetRelianceFooter: React.FC = () => {
    return (
        <div className={"asset-reliance-footer"}/>
    )
}

export default AssetRelianceFooter;